import { CommandButton, FooterMenu } from "components"
import { Fragment, PropsWithChildren } from "react"
import { useToggle } from "utils"
import { AttachmentModal } from "./AttachmentModal"
import { PrintTransferItem } from "./PrintTransferItem"

type CommandButtonsProps = {
  approvalView?: boolean
  showSaveButton?: boolean
  showDeleteButton?: boolean
  onDelete?: () => void
  handlePrint?: () => void
  onSave?: () => void
}

export const CommandButtons = (props: PropsWithChildren<CommandButtonsProps>) => {
  // const modalJournalInvoice = useToggle(false)
  const modalPrint = useToggle(false)

  return (
    <div className={props?.approvalView ? "hidden" : ""}>
      <FooterMenu
        hasCancelButton
        print={{ actiontype: "print", onClick: modalPrint.toggle }}
        // journal={{ actiontype: "journal", onClick: modalJournalInvoice.toggle }}
        customElement={{
          save: (
            <Fragment>
              {props?.showSaveButton && (
                <CommandButton
                  actiontype="save"
                  type="button"
                  color="primary"
                  permission="ST121"
                  onClick={props?.onSave}
                />
              )}
            </Fragment>
          ),

          delete: (
            <Fragment>
              {props?.showDeleteButton && (
                <CommandButton actiontype="delete" onClick={props?.onDelete} />
              )}
            </Fragment>
          ),

          attachment: <AttachmentModal/>
        }}
      />

      {modalPrint.isActive ? (<PrintTransferItem toggle={modalPrint.toggle} />) : null}
    </div>
  )
}
